import * as THREE from "three";
import Experience from "../../../Experience.js";

export default class Lights {
    constructor(bounds) {
        this.experience = new Experience();
        this.debug = this.experience.debug;

        this.bounds = bounds;

        this.sunLight = new THREE.DirectionalLight(0xffffff, 1.3);
        this.sunLight.position.set(-80, 50, 20);
        this.sunLight.castShadow = true;
        this.sunLight.shadow.camera.far = 200;
        this.sunLight.shadow.camera.left = -bounds.width;
        this.sunLight.shadow.camera.right = bounds.width;
        this.sunLight.shadow.camera.top = bounds.depth;
        this.sunLight.shadow.camera.bottom = -bounds.depth;
        this.sunLight.shadow.mapSize.set(2048, 2048);
        this.sunLight.shadow.radius = 4;
        this.sunLight.shadow.bias = -0.004; // Adjusted bias to reduce shadow acne
        this.sunLight.shadow.normalBias = 0.0;

        this.ambientLight = new THREE.AmbientLight(0x87a3ba, 0.85);

        this.sunLightHelper = new THREE.DirectionalLightHelper(
            this.sunLight,
            5,
        );
        this.sunLightHelper.visible = false;
        this.experience.scene.add(this.sunLightHelper);

        this.sunLightShadowHelper = new THREE.CameraHelper(
            this.sunLight.shadow.camera,
        );
        this.sunLightShadowHelper.visible = false;
        this.experience.scene.add(this.sunLightShadowHelper);

        this.params = {
            sunColor: this.sunLight.color.getHex(THREE.SRGBColorSpace),
            ambientColor: this.ambientLight.color.getHex(THREE.SRGBColorSpace),
            helper: false,
            shadowHelper: false,
        };

        // Debug
        if (this.debug.active) {
            this.debugFolder = this.debug.ui.addFolder("Lights");

            this.debugFolder
                .addColor(this.params, "sunColor")
                .name("Sun Color")
                .onChange((v) => {
                    this.sunLight.color.setHex(v, THREE.SRGBColorSpace);
                    this.sunLightHelper.update();
                    this.sunLightShadowHelper.update();
                });
            this.debugFolder
                .add(this.sunLight, "intensity")
                .name("Sun Intensity")
                .min(0)
                .max(10)
                .step(0.01);

            this.debugFolder
                .add(this.sunLight.position, "x")
                .name("Sun PositionX")
                .min(-100)
                .max(100)
                .step(1)
                .onChange(() => {
                    this.sunLightHelper.update();
                    this.sunLightShadowHelper.update();
                });
            this.debugFolder
                .add(this.sunLight.position, "y")
                .name("Sun PositionY")
                .min(-100)
                .max(100)
                .step(1)
                .onChange(() => {
                    this.sunLightHelper.update();
                    this.sunLightShadowHelper.update();
                });
            this.debugFolder
                .add(this.sunLight.position, "z")
                .name("Sun PositionZ")
                .min(-100)
                .max(100)
                .step(1)
                .onChange(() => {
                    this.sunLightHelper.update();
                    this.sunLightShadowHelper.update();
                });

            this.debugFolder
                .addColor(this.params, "ambientColor")
                .name("Ambient Color")
                .onChange((v) => {
                    this.ambientLight.color.setHex(v, THREE.SRGBColorSpace);
                });
            this.debugFolder
                .add(this.ambientLight, "intensity")
                .name("Ambient Intensity")
                .min(0)
                .max(10)
                .step(0.01);
            this.debugFolder
                .add(this.sunLight.shadow, "normalBias")
                .name("Sun Normal Bias")
                .min(-1)
                .max(1)
                .step(0.01);
            this.debugFolder
                .add(this.sunLight.shadow, "bias")
                .name("Sun Bias")
                .min(-0.01)
                .max(0.01)
                .step(0.0001);

            this.debugFolder
                .add(this.params, "helper")
                .name("Sun Light Helper")
                .onChange((v) => {
                    this.sunLightHelper.visible = v;
                });

            this.debugFolder
                .add(this.params, "shadowHelper")
                .name("Shadow Map Helper")
                .onChange((v) => {
                    this.sunLightShadowHelper.visible = v;
                });
        }
    }
}
